import React, { useRef, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { registerModal, useModal } from '@gluedigital/modal'
import { UploadType, useUploadFiles } from 'src/hooks/api'

import './UploadCSVModal.sass'
import Loading from 'src/components/Loading/Loading'
import ToggleSwitch from 'src/components/ToggleSwitch/ToggleSwitch'

const UploadCSVModal = () => {
  const modal = useModal()

  const defaultFiles = { fileUser: null, fileActives: null, fileUserActives: null }

  const intl = useIntl()
  const [csvFiles, setCsvFiles] = useState(defaultFiles)
  const [typeOfLoad, setTypeOfLoad] = useState<UploadType>('partial')
  const filesRef = useRef<HTMLInputElement[]>([])
  const files = ['fileUser', 'fileActives', 'fileUserActives']

  // Upload rules: you can upload a single file now (or any combination of them)
  const upload = useUploadFiles()
  const canUpload = csvFiles.fileUser || csvFiles.fileActives || csvFiles.fileUserActives

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log('submit')
    const allFilesUploaded = Object.values(csvFiles).every((field) => field !== null)
    if (typeOfLoad === 'complete' && !allFilesUploaded) {
      filesRef.current.forEach((ref) => {
        ref.files.length === 0
          ? ref.setCustomValidity(intl.formatMessage({ id: 'upload-csv-modal.form-error' }))
          : ref.setCustomValidity('')
        ref.reportValidity()
      })
    } else {
      upload.send(csvFiles, typeOfLoad)
    }
  }

  if (upload.status === 'sending') {
    return (
       <div className="modal-content upload-csv-modal">
         <h1><FormattedMessage id="upload-csv-modal.title" /></h1>
         <p><FormattedMessage id="upload-csv-modal.loading" /></p>
         <Loading />
       </div>
    )
  }

  if (upload.status === 'success') {
    return (
       <div className="modal-content upload-csv-modal">
         <h1><FormattedMessage id="upload-csv-modal.title" /></h1>
         <p><FormattedMessage id="upload-csv-modal.success" /></p>
         <button onClick={() => modal.hide()}>
           <FormattedMessage id="upload-csv-modal.close" />
         </button>
       </div>
    )
  }

  return (
    <div className="modal-content upload-csv-modal">
      <h1><FormattedMessage id="upload-csv-modal.title" /></h1>
      <form onSubmit={handleSubmit} id="upload-csv-form">
        <p><FormattedMessage id="upload-csv-modal.text" /></p>
        <button type="button">
          <a href="Ficheros_CSV.zip?v2" download>
            <FormattedMessage id="upload-csv-modal.download-template" />
          </a>
        </button>
        <div className="form-grid">
          {files.map((v, index) =>
            <label key={v} className={csvFiles[v] ? 'success' : ''}>
              {csvFiles[v]
                ? <div className="success-file">
                    <div className="check" />
                    <p>{csvFiles[v]?.name}</p>
                </div>
                : <>
                  <p><FormattedMessage id={`upload-csv-modal.select-file-${v}`} /></p>
                  <span className="button filled">
                    <FormattedMessage id="upload-csv-modal.select-file" />
                  </span>
                </>
              }
              <input
                type="file"
                name={v}
                ref={(el) => { filesRef.current[index] = el }}
                onChange={e => {
                  setCsvFiles({ ...csvFiles, [v]: e.target.files[0] })
                  e.target.setCustomValidity('')
                }}
                accept={'.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
                 ' application/vnd.ms-excel'}
              />
            </label>
          )}
        </div>
        <div className="load-type">
          <span className={typeOfLoad === 'partial' ? 'selected' : ''}>
            <FormattedMessage id="upload-csv-modal.partial" />
          </span>
          <ToggleSwitch
            value={typeOfLoad !== 'partial'}
            onChange={() => setTypeOfLoad((prev) => prev === 'complete' ? 'partial' : 'complete')}
          />
          <span className={typeOfLoad === 'complete' ? 'selected' : ''}>
            <FormattedMessage id="upload-csv-modal.complete" />
          </span>
        </div>

        <p><FormattedMessage id={`upload-csv-modal.${typeOfLoad}-new-file`} /></p>
        <button
          disabled={!canUpload}
          className="filled"
          type="submit"
        >
          <FormattedMessage id="import" />
        </button>
        {upload.status === 'error' &&
          <p className="error">
            <FormattedMessage id="upload-csv-modal.error" />
          </p>
        }
      </form>
    </div>
  )
}

registerModal('upload-csv-modal', UploadCSVModal)
